import { Button } from '@/components/ui/button'
import { ask, choicesOf } from '../list/bulkHelpers'
import { ChoiceButton, ChoiceList, MenuPopover, type BulkRequest } from '../list/BulkMenus'
import type { FilterOptions } from '../filters/useFilterOptions'
import type { Register } from '../query/types'

/**
 * The bulk buttons of Afspraken (design §5.6): Eigenaar, Pauzeren, Beëindigen, Exporteren. Each one
 * asks first; there is no undo for these.
 */
export function AgreementBulkMenus({
  register,
  options,
  onRequest,
  onExport,
}: {
  register: Register
  options: FilterOptions
  archived: boolean
  onRequest: (request: BulkRequest) => void
  onExport: () => void
}) {
  // "Ik" and "Niemand" are for filters; a bulk owner is a member of the team.
  const team = choicesOf(register, options, 'owner')?.filter((choice) => choice.value !== 'me' && choice.value !== 'none') ?? null
  return (
    <>
      <MenuPopover label="Eigenaar" onRequest={onRequest}>
        {(choose) => (
          <ChoiceList
            label="Eigenaar"
            choices={team}
            row={(choice) => (
              <ChoiceButton
                key={choice.value}
                onClick={() => choose({ ...ask('owner', { owner_user_id: choice.value }, `eigenaar ${choice.label} zetten`), confirm: true })}
              >
                {choice.label}
              </ChoiceButton>
            )}
          />
        )}
      </MenuPopover>
      <Button type="button" variant="outline" size="sm" onClick={() => onRequest(ask('pause', {}, 'pauzeren'))}>
        Pauzeren
      </Button>
      <Button type="button" variant="outline" size="sm" onClick={() => onRequest(ask('end', {}, 'beëindigen'))}>
        Beëindigen
      </Button>
      <Button type="button" variant="outline" size="sm" onClick={onExport}>
        Exporteren
      </Button>
    </>
  )
}
